import React from "react";
export const useDebounce = (value, delay, updateAction) => {
    const [getDebouncedValue, setDebouncedValue] = React.useState(value);
    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
            updateAction && updateAction();
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return getDebouncedValue;
};
//# sourceMappingURL=useDebounce.js.map